import Nullstack from 'nullstack';
export default function IconTestPipe({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-test-pipe",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20 8.04l-12.122 12.124a2.857 2.857 0 1 1 -4.041 -4.04l12.122 -12.124"
  }), "   ", Nullstack.element("path", {
    d: "M7 13h8"
  }), "   ", Nullstack.element("path", {
    d: "M19 15l1.5 1.6a2 2 0 1 1 -3 0l1.5 -1.6z"
  }), "   ", Nullstack.element("path", {
    d: "M15 3l6 6"
  }), " ");
}